export class TimeoutError extends Error {
  timeoutMilliseconds;
  constructor(message, ms = 0) {
    super(message);
    Object.setPrototypeOf(this, TimeoutError.prototype);

    this.timeoutMilliseconds = ms;
  }
}

const promiseTimeout = (promise, cleanProm = () => {}, timeoutMilliseconds = 5000, correlationId, eventNames = []) => {
  var timeout;

  return Promise.race([
    promise,
    new Promise(function (resolve, reject) {
      timeout = setTimeout(function () {
        reject(
          new TimeoutError(
            `The events [${eventNames.join(
              ", "
            )}] are awaited, but none reached the client in ${timeoutMilliseconds}ms.\nCorrelationId: ${correlationId}`,
            timeoutMilliseconds
          )
        );
      }, timeoutMilliseconds);
    })
  ]).then(
    v => {
      clearTimeout(timeout);
      cleanProm();
      return v;
    },
    err => {
      clearTimeout(timeout);
      cleanProm();
      throw err;
    }
  );
};

export default promiseTimeout;
